const en = {
    navtophome: 'Home',
    navtopTechnical: 'Technical Engine',
    navtopTurnkey: 'Turn-key Solution',
    navtopOpen: 'Product Center',
    navtopAbout: 'About US',
    navtopKnowledge: 'Knowledge Hub',
    navtopabout: 'About',
    navtoptech: 'Product Blog',
    navtopproduct: 'Product',
    navtopsolution: 'Solution',
    navtopjoinUS: 'Join us',
    navtopcontact: 'Contact',
    Function: "Function",
    Feature: "Feature",
    Scenario: "Scenario",
    Application: "Application",
    UseSecne: "Application Scenarios",


    AFeatureT0: "Big Dataset",

    AFeatureT1: "High Accuracy",

    AFeatureT2: "Scenario Optimization",

    AFeatureT3: "Multiple Attribute",

    AFeatureT4: "Anti Spoofing",

    AFeatureT5: "Various Angle",


    AFeatureTP0: "Mass image set from the real surveillance camera, auto labeling or human labeling",

    AFeatureTP1: "At 1:20000, the accuracy is higher than 98%, and false rate is lower than 0.05%",

    AFeatureTP2: "The algorithm will be optimized against the scenario, and be upgraded continuously",

    AFeatureTP3: "Multiple attribute of human face, hat, mask, gender, age, expression etc.",

    AFeatureTP4: "Anti spoofing by dual camera, calculate the distance and parallax, video and photo can be rejected",

    AFeatureTP5: "Support various angle of human, select the best image and do face recognition",



    AScenarioT0: "Door Access",

    AScenarioT1: "Face Verification",

    AScenarioT2: "Face Attribute",



    AScenarioTP0: "Used in door access, the face is recognized and check the permission",

    AScenarioTP1: "Verify the ID card holder is legal and identical",

    AScenarioTP2: "Recognize more attribute of the face such as mask, gender, etc.",


    BFeatureT0: "Big Dataset",
    BFeatureT1: "Fast",
    BFeatureT2: "Scenario Optimization",
    BFeatureT3: "Redundancy Removal",
    BFeatureT4: "High Accuracy",
    BFeatureT5: "Customization",
    BFeatureTP0: "Mass image set from the real surveillance camera, auto labeling or human labeling",
    BFeatureTP1: "Achieve real-time analysis on edge device with optimized model",
    BFeatureTP2: "The algorithm will be optimized against the scenario, and be upgraded continuously",
    BFeatureTP3: "Complex logic to remove redundancy by Re-ID and face recognition",
    BFeatureTP4: "Recognize human body joint and gesture with high accuracy",
    BFeatureTP5: "Support defined behavior and gesture training and recognition",
    BScenarioT0: "Customer Statistics Access",
    BScenarioT1: "Behavior Analysis",
    BScenarioT2: "Pose Recognition",
    BScenarioTP0: "Based on Re-ID and face recognition to achieve 90% accuracy in person counting",
    BScenarioTP1: "Analyze human body, action and gesture, it could be used to detect fatigue driving and falling down, etc",
    BScenarioTP2: "Recognize every joint of human to check whether the pose is correct or not",


    CFeatureT0: "Big Dataset",
    CFeatureT1: "Redundancy Removal",
    CFeatureT2: "Scenario Optimization",
    CFeatureT3: "High Accuracy",
    CFeatureT4: "Fast",
    CFeatureT5: "Multiple Attribute",
    CFeatureTP0: "Mass image set from the real surveillance camera, auto labeling or human labeling",
    CFeatureTP1: "Complex logic to trace the car by Re-ID and plate number recognition",
    CFeatureTP2: "The algorithm will be optimized against the scenario, and be upgraded continuously",
    CFeatureTP3: "Recognize car plate number and attribute with high accuracy",
    CFeatureTP4: "Achieve real-time analysis on edge device with optimized model",
    CFeatureTP5: "Output multiple attributes in terms of color and model",
    CScenarioT0: "Smart Access",
    CScenarioT1: "Illegal Parking",
    CScenarioT2: "Traffic Flow",
    CScenarioTP0: "Based on plate number, model and other attributes of car to identify the car, achieve smart access control",
    CScenarioTP1: "Analyze whether the area is allowed for parking, and recognize the plate number, model for illegal parking",
    CScenarioTP2: "Recognize the vehicle and bicycle to calculate the real-time traffic flow",

    OFeatureT0: "Big Dataset",
    OFeatureT1: "Fast",
    OFeatureT2: "Scenario Optimization",
    OFeatureT3: "High Accuracy",
    OFeatureT4: "Location Information",
    OFeatureT5: "Customization",
    OFeatureTP0: "Mass image set from the real surveillance camera, auto labeling or human labeling",
    OFeatureTP1: "Achieve real-time analysis on edge device with optimized model",
    OFeatureTP2: "The algorithm will be optimized against the scenario, and be upgraded continuously",
    OFeatureTP3: "Recognize the target object and its attributes with high accuracy",
    OFeatureTP4: "The location information could be exported and used to determine movement",
    OFeatureTP5: "Upload interested object images and recognize at the edge",
    OScenarioT0: "Logo Detection",
    OScenarioT1: "Object Detection",
    OScenarioT2: "Unknown Lost Recognition",
    OScenarioTP0: "Recognize the specific logo in video stream and image",
    OScenarioTP1: "Detect specific objects, for example, helmet, badge and suit",
    OScenarioTP2: "Recognize whether the object belongs to this scene",


    Neucore: 'Neucore',
    'To be the leading vendor of edge AI in China': 'To be the leading vendor of edge AI in China',
    'See Our Solution': 'Product Center',
    homeproduct: "Our Products",
    homeproductdesc: "The comprehensive line of products fully utilize computing power and achieve the maximum performance on edge device and cloud platform.",
    homeproductseH0: 'NeuEdge Module',
    homeproductseP0: 'Vision and voice module based on edge computing SoCs, the modules have fine-tuned vision and voice algorithm built-in. ',
    homeproductseH1: 'NeuBoard Kit',
    homeproductseP1: 'The NeuBoard kit serves as fog platform, supports multiple vision and voice streams and analyzes the content in real-time. ',
    homeproductseH2: 'NeuOS SDK',
    homeproductseP2: 'The cutting-edge SDK provides optimized A.I. algorithms, various interfaces and full function protocol to application developers.',
    homeproductseH3: 'NeuServer Cloud',
    homeproductseP3: 'Public or private server could be deployed to manage all the devices, and as SAAS platform to support various services.',
    homesolution: "Our Solution",
    homesolutiondesc: "In order to help our partners shorten time to market, the turn-key solutions are well designed and optimized based on our understanding of vertical industry market.",
    homesolutionbtn: "More Details",
    homesolutionp0: "New Retail",
    homesolutionp1: "New Industry",
    homesolutionp2: "ADAS",
    homesolutionp3: "Smart Home",
    homesolutionp4: "New Security",
    homesolutionp5: "Smart Gate",
    homecontact: "Contact Us",

    homenavFT: "Face Recognition",
    homenavFT0: "Face Detection",
    homenavFT1: "Multi Face Detection",
    homenavFT2: "Face Attribute",
    homenavFT3: "Factures Location",
    homenavFT4: "Face Recognition",
    homenavFT5: "Face Verification",
    homenavFT6: "Face Antispoofing",
    homenavFT7: "Face feature value",
    homenavFT8: "Face 106landmark",

    RetailScenario: "Scenario",
    RetailFlow: "Flow",
    RetailFlowH0: "New",
    RetailFlowH1: "Upgrade",
    RetailArchitecture: "Architecture",
    RetailFeature: "Feature",

    RetailFeatureH0: "Low Cost",
    RetailFeatureP0: "No local or cloud AI server is required, everything is running on edge",

    RetailFeatureH1: "Fast Deployment",
    RetailFeatureP1: "The architect is quite simple, easy for deployment and maintenance",

    RetailFeatureH2: "Innovative Model",
    RetailFeatureP2: "Algorithm and function could be activated and managed remotely",

    homenav1RT: "New Retail",
    homenav1RT0: "Customer Portrait",

    homenav1RT0P0: "By face detection and comparing with face library, the system is able to recognize the VIP customer and notify sales. So the sales could provide the best service and care, improve customer satisfaction and close the deal.",
    homenav1RT0P1: "In the meanwhile, by matching the record and customer’s interests, the system could provide more information to implement accurate marketing.",
    homenav1RT0P2: "Deployment: Smart Camera or AI Edge Box, AIoT Cloud",
    homenav1RT0P3: "Technical Engine: Face Recognition",

    homenav1RT1: "Long-range Cruise Shop",
    homenav1RT1P0: "Based on body detection and tracking, face detection, redundancy removal logic, the first seen time and last seen time of the specific person, the system could calculate the length of stay within today.",
    homenav1RT1P1: "The length of stay and statistics information could reflect whether the sales have done great job, and whether the person is a potential customer.",
    homenav1RT1P2: "Deployment: Smart Camera or AI Edge Box, AIoT Cloud",
    homenav1RT1P3: "Technical Engine: Body Analysis, Face Recognition",

    homenav1RT2: "Traffic statistics",
    homenav1RT2P0: "Based on body detection and tracking, face detection, redundancy removal logic, the system could detect the amount of person, the amount of VIP customer.",
    homenav1RT2P1: "The customer statistics information is very important to operation, through various view – day, week, and month, the operator could understand the status and make the right decision.",
    homenav1RT2P2: "Deployment: Smart Camera or AI Edge Box, AIoT Cloud",
    homenav1RT2P3: "Technical Engine: Body Analysis, Face Recognition",

    homenav1RT3: "Hot Spot Region",
    homenav1RT3P0: "Based on body detection and tracking, face detection, redundancy removal logic, the system could detect the amount of person, with the layout map, the system could draw the hot spot region with different colors.",
    homenav1RT3P1: "Such information could reflect whether the promotion meet the expectation, whether promotion activity is necessary, and lead the customer to the right region.",
    homenav1RT3P2: "Deployment: Smart Camera or AI Edge Box, AIoT Cloud",
    homenav1RT3P3: "Technical Engine: Body Analysis",

    homenav1RT4: "Employee Presense",
    homenav1RT4P0: "Based on body analysis, face detection and face recognition, the system could compare the face with employee library to detect whether the employ is on duty, such system is more user-friendly, so the employee could focus on daily job. ",
    homenav1RT4P1: "Deployment: Smart Camera or AI Edge Box, AIoT Cloud",
    homenav1RT4P2: "Technical Engine: Body Analysis, Face Recognition",

    homenav1RT5: "Remote Video Patrol",
    homenav1RT5P0: "The operator could connect to the cameras anytime and anywhere through mobile application or PC web browser, and view the real-time status, check the specific region, or even listen and talk to the people.",
    homenav1RT5P1: "Deployment: Smart Camera, AIoT Cloud",

    homenav1ET: "Smart Security",
    homenav1ET1: "Human Analysis",

    homenav1ET1P0: "By deploying smart cameras at the entry of campus, the system will capture multiple faces, recognize the faces and identify the students, teachers and parents, it could accelerate the access the passing efficiency.",

    homenav1ET1P1: "As for dormitory, laboratory, library and other places requiring ID card, the system could verify the face is identical to the ID card holder to make sure the security is ",

    homenav1ET1P2: "Deployment: Smart Camera, Facial Access",

    homenav1ET1P3: "Technical Engine: Face Recognition, Face Verification",
    homenav1ET2: "Traffic Analysis",

    homenav1ET2P0: "The front cameras in the classroom can capture all the faces of students and do the recognition within few seconds, and the process can be start at a fixed frequency, for instance, every 5 minutes, the system can implement auto class sign-in and get the accurate presence rate.",

    homenav1ET2P1: "Deployment: Smart Camera",

    homenav1ET2P2: "Technical Engine: Face Recognition",
    homenav1ET3: "Object Analysis",
    homenav1ET3P0: "The front cameras can detect a lot of information such as count, pose, behavior, expression and analyze the concentration, absence rate, the solution is also suitable for remote training scenario.",


    homenav1ET3P1: "Deployment: Smart Camera",

    homenav1ET3P2: "Technical Engine: Face Recognition, Face Attribute, Pose Analysis, Body Analysis",
    homenav1ET4: "Campus Security",

    homenav1ET4P0: "By integrating the face capture, search with face image, the system builds a real-time warning and structured video search system to resolve the latency and video play back paint points. ",

    homenav1ET4P1: "Deployment: Smart Camera",

    homenav1ET4P2: "Technical Engine: Face Recognition, Behavior, Survillance",
    homenav1BT: "Smart Vehicle",
    homenav1BT0: "Analysis of passenger and passenger behavior",
    homenav1BT1: "Advanced Driving assistance",
    homenav1BT2: "Visitor Management",
    homenav1BT3: "Smart Advertisement",
    homenav1FT: "Smart Factory",
    homenav1FT0: "Label Recognition",
    homenav1FT1: "Object Recognition",
    homenav1FT2: "Area Monitor",
    homenav1CT: "Bus & Car",
    homenav1CT0: "Passenger Statistice",
    homenav1CT1: "Criminal Face Recognition",
    homenav1CT2: "Fatigue Detection",
    homenav1SCT: "Smart Field",
    homenav1SCT0: "Helmet Detection",
    homenav1SCT1: "Gate Control",
    homenav1SCT2: "Worker Tracing",
    homenav1SHT: "Smart Hospital",
    homenav1SHT0: "Face Verification",
    homenav1SHT1: "Blacklist",
    homenav1SPT: "Smart Parking",
    homenav1SPT0: "Parking Charge",
    homenav1SPT1: "Car Location",

    homenavBT: "Body Gesture",
    homenavBT0: "Human Detection",
    homenavBT1: "Re-ID & Tracking",
    homenavBT2: "Gesture Recognition",
    homenavBT3: "Pose Recognition",

    homenavCT: "Car Analysis",
    homenavCT0: "Car Detection",
    homenavCT1: "Car Model Recognition",
    homenavCT2: "Car Attribute",
    homenavCT3: "Car Plate Detection",

    homenavOT: "Object Detection",
    homenavOT0: "Logo Detection",
    homenavOT1: "Unkown Left Detection",
    homenavOT2: "Helmet Detection",

    homenewTH0: "Full Stack AI Technology From Edge To Cloud",
    homenewTHP0: "Smart Edge",
    homenewTHP1: "AI Algorithm",
    homenewTHP2: "AIOT Cloud",

    homenewTH1: "Turn-key Solutions Enable The Industry",
    homenewTH2: "Open Platforms For AI Customization",
    homenewTH3: "Partners And Eco-system",

    homenav2HPT: "Edge Server",
    homenav2HPT0: "Smart Box",
    homenav2HPT1: "Vision Development Suite",
    // homenav2HPT2: "Audio Development Suite",
    // homenav2HPT3: "Camera Modle",
    homenav2SPT: "Software Platform",
    homenav2SPT0: "NeuSDK Linux SDK",
    homenav2SPT1: "NeuSDK Android SDK",
    homenav2SPT2: "Cloud Docker",
    homenav2SNT: "Smart Camera",
    homenav2SNT0: "Smart Camera",
    homenav2SNT1: "IPC",
    homenav2SNT2: "Plate Recognition Camera",
    homenav2SNT3: "All Structure Camera",

    homenavCamera0: "Smart Camera",
    homenavCamera1: "IPC",

    homenavSdk0: "NeuSDK SDK",
    homenavSdk1: "NeuSDK Linux SDK",
    homenavSdk2: "NeuSDK Android SDK",

    SdkDescription: "Based on the unique HCS framework, Neucore realizes the rapid transplantation of algorithm in CPU, NPU, GPU, DSP and other architectures, and realizes intelligent localization of high-precision face capture, face recognition, human body capture, attribute analysis, behavior recognition and other functions. This page will update the latest algorithm listings and Demo code.",

    homenavCameraH0: "Smart Camera",
    homenavCameraH0_800: "Smart Camera_8 million",
    homenavCameraH0_500: "Smart Camera_5 million",
    homenavCameraH0_200: "Smart Camera_2 million",
    homenavCameraH1: "IPC",
    homenavCameraH1_800: "IPC_8 million",
    homenavCameraH1_500: "IPC_5 million",
    homenavCameraH1_200: "IPC_2 million",


    CameraDetaulH1: "NeuCamera Smart Camera",
    CameraDetaulH2: "NeuCamera IPC",

    homenavBoard0: "Smart Box",
    homenavBoard1: "Vision Development Suite",
    homenavBoardH0: "NeuBoard",
    homenavBoardH0_28: "NeuBoard2+8",
    homenavBoardH0_416: "NeuBoard4+16",
    homenavBoardH1: "Vision Development Suite",
    homenavBoardH1_28: "Vision Development Suite2+8",
    homenavBoardH1_416: "Vision Development Suite4+16",
    boardDesctiption: "Neucore NeuBoard series intelligent analysis box adopts low power consumption and high performance ARTIFICIAL intelligence chip, as well as advanced artificial intelligence algorithm of Neucore. While realizing real-time decoding of multi-channel 1080P video stream, NeuBoard series intelligent analysis box carries out various target detection and identification respectively, which can reduce the burden and reduce the system cost for your network and server as much as possible. 50,000-capacity target base library, HDMI image real-time display, flexible channel configuration, over 99% recognition rate, millisecond response speed. The product is equipped with industrial-grade metal housing, fanless design, natural and efficient heat dissipation, stable operation in environments as low as -30°C and as high as +80°C. With rich interfaces and strong applicability, it can be quickly applied to edge computing scenarios such as intelligent monitoring, person/car detection and identification, list control, etc",

    homenavModule: "Camera Module",
    homenavModule0: "Face Capture Module",
    homenavModule1: "Face Recognition Module",
    homenavModule2: "Plate Recognition Module",
    homenavModule3: "All Structure Module",
    homenavModule4: "IPC Module",
    ModuleDetaulH1: "Face Capture Module",
    ModuleDetaulH2: "Face Recognition Module",
    ModuleDetaulH3: "Plate Recognition Module",
    ModuleDetaulH4: "All Structure Module",
    ModuleDetaulH5: "IPC Module",
    ModuleDetaulH1_800: "Face Capture Module_8",
    ModuleDetaulH1_500: "Face Capture Module_5",
    ModuleDetaulH1_200: "Face Capture Module_2",
    ModuleDetaulH2_800: "Face Recognition Module_8",
    ModuleDetaulH2_500: "Face Recognition Module_5",
    ModuleDetaulH2_200: "Face Recognition Module_2",
    ModuleDetaulH3_800: "Plate Recognition Module_8",
    ModuleDetaulH3_500: "Plate Recognition Module_5",
    ModuleDetaulH3_200: "Plate Recognition Module_2",
    ModuleDetaulH4_800: "All Structure Module_8",
    ModuleDetaulH4_500: "All Structure Module_5",
    ModuleDetaulH4_200: "All Structure Module_2",
    ModuleDetaulH5_800: "IPC Module_8",
    ModuleDetaulH5_500: "IPC Module_5",
    ModuleDetaulH5_200: "IPC Module_2",


    homenewConstruction: "Smart Construction",
    homenewTransportation: "Smart Parking",
    homenewFactory: "Smart Factory",
    homenewEducation: "Smart Education",
    homenewBuilding: "Smart Building",
    homenewRetail: "New Retail",
    homenewHos: "Smart Hospital",
    homenewBus: "Bus & Car",

    changeNum0D: "Technical Engines",
    changeNum1D: "Open Platforms",
    changeNum2D: "hour",
    changeNum2De: "Fast Integration",


    homenewTan0NPU: "Development Suite",
    homenewTan0NPUDesc: "The AI development board has high TOPs NPU and full interfaces, support Ubuntu, neuxos and Android OS.",
    homenewTan0interfaces: "Camera Module",
    homenewTan0interfacesDesc: "The industry standard module, size is 38 x 38, the module has main board, sensor and lens, with extension board.",
    homenewTan0products: "ODM Product",
    homenewTan0productsDesc: "The complete devices use public mould and run neuxos. The devices pass stress test, support NVR and cloud platform.",
    homenewTan0Os: "Edge Box",
    homenewTan0OsDesc: "The  edge computing box supports up to four 1080P video streams, either IP/UVC camera, or video clip, analyses the content.",

    homenewTan1det: "Face Recognition",
    homenewTan1detD: "Face detection with logic to filter the best one and reduce redundant faces, generate face-id, face recognition, and attribute.",
    homenewTan1any: "Body Gesture",
    homenewTan1anyD: "Gesture and body pose recognition, and the pose information could be used to recognize complex behavior.",
    homenewTan1car: "Car Analysis",
    homenewTan1carD: "Detect Automotive, and extract the structural information in terms of the type, color, model, logo, and the plate number.",
    homenewTan1so: "Object Detection",
    homenewTan1soD: "General object detection, for example, detect the obstacle, or unknown left objects.",

    homenewTan2equ: "Device Management",
    homenewTan2equD: "Device management service is monitoring all the devices through MQTT  technology to remote control, OTA upgrade, etc",
    homenewTan2bd: "Big Data",
    homenewTan2bdD: "Recognize and extract key information from image and video, labelling and generate massive data to train the AI networks.",
    homenewTan2trans: "P2P Video",
    homenewTan2transD: "The cutting-edge P2P technology offers real-time and low latency video and audio streaming service.",
    homenewTan2charts: "Business Report",
    homenewTan2chartD: "The console, dashboard and applications for PC, Android, IOS make the business report is much more useful and efficient.",

    detail_label0: 'Product Overview',
    detail_label1: 'Technical Parameters',
    detail_label2: 'Document Download',
    ProductDetail: 'more',

    moduleDesctiption: "Neucore NeuCamera intelligent camera series, with low power consumption high-performance chip, artificial intelligence, and Neucore advanced artificial intelligence algorithm, the realization of 5 m / 5 m pixels of real-time video coding time, people/car/content such as object recognition. Multiple ways to de-load your network and servers to the maximum extent possible. 50000 extensive capacity target library, flexible function configuration. Over 99% recognition rate, millisecond response time. Easy to operate and install. Simple natural heat dissipation design, easy to use in a variety of high and low-temperature environments. Support local and remote upgrade, let you worry after-sales. The product provides a rich development interface. If you need, support the application's secondary development, convenient to customize the application according to the business needs.",

    moduleAdH0: 'Computing Power',
    moduleAdP00: '1、Artificial intelligence master chip, built-in independent 4TOPS NPU',
    moduleAdP01: '2、Dual-core A55 design, master frequency up to 2.0GHz, peak speed and low power consumption',

    moduleAdH1: 'Open computing power',
    moduleAdP10: '1、Support the mainstream network training model instances, no need to retrain the network, model training tools immediately',
    moduleAdP11: '2、Support the conversion of Caffe, PyTorch, Tensorflow and Onnx models. Provides 8bit quantization, 16bit quantization and mixed quantization support by layer',

    moduleAdH2: 'Built-in Algorithm ',
    moduleAdP20: '1、Face Detection',
    moduleAdP21: '2、Human Detection',

    moduleAdH3: 'Cloud Edge Fusion',
    moduleAdP30: '1、Support NeuLink protocol access to Neucore public cloud platform and private cloud platform deployment, support mainstream Ali cloud /AWS platforms',

    moduleAdH4: 'Rich interface',
    moduleAdP40: '1、Support wide dynamic single channel 8 million or 5 million input, independent ISP and 3A algorithm',
    moduleAdP41: '2、Support 100M/1000M adaptive network port',
    moduleAdP42: '3、Supports MicroSD/Micro SDHC/Micro SDXC CARDS (64GB/128GB/256GB) for local storage',
    moduleAdP43: '4、1 channel DC12V power input, TDP≤2.5W',

    moduleAdH5: 'Multipath multimode',
    moduleAdP50: '1、Support 4-way 1080P webcam and USB camera real-time decoding, real-time detection and recognition of people, cars and other targets',

    BoardDetaulH1: 'NeuBoard',
    BoardDetaulH2: 'Vision Development Suite',

    boardAdP00: '1、Support mainstream network training model instances, no need to retrain the network, model training tools are ready to use',
    boardAdP01: '2、4 core A73+2 core A53 size core design, main frequency up to 2.2ghz, peak speed and low power consumption',

    boardAdP10: '1、Artificial intelligence master chip, built-in independent 5TOPS NPU',
    boardAdP11: '2、Support conversion of Caffe, PyTorch, Tensorflow and Onnx models. Provides 8bit quantization, 16bit quantization and mixed quantization support by layer',

    boardAdP20: '1、Human body structure algorithm: face detection, face recognition, gender and age, hat glasses, human body detection, human body node, gesture recognition, etc',
    boardAdP21: '2、Vehicle structure algorithm: vehicle detection, license plate recognition, body color, etc',
    boardAdP22: '3、Support algorithm customization development',

    boardAdP40: '1、Support NeuLink protocol access to Neucore public cloud platform and private cloud platform deployment, support mainstream Ali cloud /AWS platforms',

    boardAdP50: '1、Support 100M/1000M adaptive network port',
    boardAdP51: '2、Supports MicroSD/Micro SDHC/Micro SDXC CARDS (64GB/128GB/256GB) for local storage',
    boardAdP52: '3、2 channels USB2.0, 1 channel MiniUSB interface',
    boardAdP53: '4、Supports HDMI display',
    boardAdP54: '5、1 channel DC12V power input, TDP≤5W',

    moduletableTH0: 'Hardware Configuration',
    moduletableTH1: 'Component',
    moduletableTH2: 'Specifications',

    boardtableTd0: 'Hardware Configuration',
    boardtableTd1: 'AmlogicA311D, quad-core Architecture A73 (2.2ghz)+ two-core ARM Architecture A53 (1.8ghz)',
    boardtableTd2: 'Independent AI neural processing unit, 5 TOPS power',
    boardtableTd3: '4KH.265, VP9 and AVS2 video decoder, support 1080ph.265 /H.264 video encoding',
    boardtableTd4: '4GB / 8GB / 16GB / 32GB eMMC5.1 supports standard 256G Micro SD/SDHC/SDXC card extended storage',
    boardtableTd5: 'interface',
    boardtableTd50: '100/1000m adaptive RJ45×1, USB2.0×2, HDMI2.1×1',
    boardtableTd6: 'Power state LED light ×1, startup state LED light ×1',
    boardtableTd7: 'DC±12V, with 220V AC power adapter, equipment power ≤5W',
    boardtableTd8: 'main function',
    boardtableTd9: 'Data access',
    boardtableTd10: 'Support up to 4 1080P access real-time decoding, support RTSP protocol and H.264/H.265 decoding standard.',
    boardtableTd11: 'It supports detection of human face, human body, license plate and vehicle, and can be detected with pixel ≥20×20. Each frame can detect target number ≥100, detection speed ≤50ms, error detection rate ≤1%, omission rate ≤1%',
    boardtableTd12: 'Remove duplicate images',
    boardtableTd13: 'Support to remove weight according to picture quality/time interval, keep the first picture, repeat rate ≤20%',
    boardtableTd14: 'Objective compare',
    boardtableTd15: 'Support real-time comparison of face and license plate. Comparison speed ≤100ms (1:50,000). False alarm rate ≤1%; false alarm rate ≤1%',
    boardtableTd16: 'Identify the results',
    boardtableTd17: 'Support date/time, channel number, target ID, snapshot picture, similarity, feature value and other recognition results upload',
    boardtableTd18: 'Data management',
    boardtableTd19: 'Support adding, deleting, modifying and checking of face database and license plate database, support batch import/export of database data; Maximum capacity: 50000',
    boardtableTd20: 'Platform support',
    boardtableTd21: 'Support for nobelium NeuLink; Support Aliyun OSS',
    boardtableTd22: 'fuselage',
    boardtableTd23: 'size',
    boardtableTd24: 'Main body 136×136×40 (mm), same fixed sides 100×15×2 (mm)',
    boardtableTd25: 'The material',
    boardtableTd26: 'Aluminium alloy matte finish',
    boardtableTd27: 'color',
    boardtableTd28: 'The night black',
    boardtableTd29: 'protective',
    boardtableTd30: 'IP31, can prevent small solid invasion; Drops of water to the shell have no effect',
    boardtableTd31: 'installation',
    boardtableTd32: 'Can be flat fixed, flat/suspended fixed',
    boardtableTd33: 'Storage temperature',
    boardtableTd34: 'Relative humidity',
    boardtableTd35: '≤95%RH, no condensation',
    boardtableTd36: 'The cooling way',
    boardtableTd37: 'Natural heat dissipation',
    boardtableTd38: 'Vibration resistance',
    boardtableTd39: 'The overall weight',
    boardtableTd40: 'Language support',
    boardtableTd41: 'Simplified Chinese and English',

    moduletableTd0: 'Project',
    moduletableTd1: 'AmlogicC308X, dual-core ARM Architecture A55',
    moduletableTd2: 'Independent AI neural processing unit, 4TOPS',
    moduletableTd3: 'Memory',
    moduletableTd4: 'Storage',
    moduletableTd5: 'Extended stored',
    moduletableTd6: 'Support standard 256G Micro SD/SDHC/SDXC card extended storage',
    moduletableTd7: 'Video input',
    moduletableTd8: '8 million sensor (Sony 415 / Sony 334) and 5 million sensor (Sony 335)',
    moduletableTd9: 'Wired network',
    moduletableTd10: 'The cable network supports POE power supply, 100/1000 m adaptive',
    moduletableTd11: 'The wireless network',
    moduletableTd12: '802.11b/g/n, support hot mode',
    moduletableTd13: 'Indicator light',
    moduletableTd14: 'Two-color indicator light, indicating power and network status',
    moduletableTd15: 'Button',
    moduletableTd16: '1 Reset button to restore factory Settings locally',
    moduletableTd17: 'The power supply',
    moduletableTd18: 'DC±12V with 220V AC power adapter, equipment power ≤2.5W',
    moduletableTd19: 'Standard interface',
    moduletableTd20: 'Audio I/O，5x GPIO，3x UART，1x USB-OTG',
    moduletableTd21: 'Plate and frame',
    moduletableTd22: 'The system software',
    moduletableTd23: 'The operating system',
    moduletableTd24: 'NeuXOS, Simplified Chinese, English',
    moduletableTd25: 'Video coding',
    moduletableTd26: '4K @30FPS + 1080P @30fps,H.265/H.264 video encoding, JPEG encoding',
    moduletableTd27: 'More stream',
    moduletableTd28: 'Support three code stream (main code stream, auxiliary code stream, third code stream) independent setting',
    moduletableTd29: 'Video conversion',
    moduletableTd30: 'Support fog removal mode, corridor mode, lens correction',
    moduletableTd31: 'Audio coding',
    moduletableTd32: 'G.711，G.726, ADPCM，AAC',
    moduletableTd33: 'OSD',
    moduletableTd34: 'Support overlay time, channel number, font size and color can be set',
    moduletableTd35: 'Day and night conversion',
    moduletableTd36: 'Support, IR-cut automatic switch',
    moduletableTd37: 'Voice intercom',
    moduletableTd38: 'Support two-way voice intercom, built-in noise reduction and echo elimination algorithm',
    moduletableTd39: 'The front-end video',
    moduletableTd40: 'Timing recording, motion detection linkage recording, 5 seconds pre-recording',
    moduletableTd41: 'Network protocol',
    moduletableTd42: 'Platform agreement',
    moduletableTd43: 'Cloud docking',
    moduletableTd44: 'Support NeuLink protocol docking Neucore cloud; Support aliyun；AmazonAWS',
    moduletableTd45: 'P2P video',
    moduletableTd46: 'Support P2P network transmission, support iPhone and Android platform real-time view video stream',
    moduletableTd47: 'The intelligence function',
    moduletableTd48: 'Support block detection, out of focus detection, motion detection, area intrusion detection, humanoid detection',
    moduletableTd49: 'Secondary development',
    moduletableTd50: 'Support to do secondary development in the camera head, to achieve more business applications',
    moduletableTd51: 'Apply to the environment',
    moduletableTd52: 'Working temperature',
    moduletableTd53: 'Reliability',
    moduletableTd54: 'MTBF≥5000h，the power was restored to itself after the blackout',
    moduletableTd55: 'Face Capture',
    moduletableTd56: 'Target Detection',
    moduletableTd57: 'For face capture in complex environment, the number of detected targets ≥100 per frame, detection speed ≤50ms, error detection rate ≤1%, and omission rate ≤1%',
    moduletableTd58: 'Image Rating',
    moduletableTd59: 'It supports the screening and scoring of moving faces',
    moduletableTd60: 'To re-election',
    moduletableTd61: 'Support to remove weight according to picture quality/time interval, keep the first picture, repeat rate ≤20%',
    moduletableTd62: 'Upload the result',
    moduletableTd63: 'Support date/time, channel number, target ID, optimal face, first face, background image',
    moduletableTd64: 'Body Capture',
    moduletableTd65: 'Target detection',
    moduletableTd66: 'It supports head, shoulder and whole body detection. The minimum detection target is 35x10',
    moduletableTd67: 'people Counting',
    moduletableTd68: 'The human body was tracked and accurately counted, and the statistical error of the number was within ±10%',
    moduletableTd69: 'Face Recognition',
    moduletableTd70: 'Face the bottom',
    moduletableTd71: 'Supports a maximum of 50,000 face base',
    moduletableTd72: 'Recognition speed',
    moduletableTd73: '30 people can be identified in one second',
    moduletableTd74: 'Recognition Precision',
    moduletableTd75: 'False alarm rate ≤1%; false alarm rate ≤1%',
    moduletableTd76: 'Human Attributes',
    moduletableTd77: 'Gender',
    moduletableTd78: 'Gender accuracy >95%',
    moduletableTd79: 'Age',
    moduletableTd80: 'Age error <3.7 years',
    moduletableTd81: 'Mask',
    moduletableTd82: 'Whether wearing mask or not, the accuracy rate is >98.6%',
    moduletableTd83: 'Keep out',
    moduletableTd84: 'The accuracy of facial occlusion is >97.3%',
    moduletableTd85: 'Backpack',
    moduletableTd86: 'Whether backpack, > 85% accuracy',
    moduletableTd87: 'Hat',
    moduletableTd88: 'Whether to wear a hat (e.g. a hard hat), the accuracy rate is > 92.5%',
    moduletableTd89: 'Uniform',
    moduletableTd90: 'Support police, express, cleaning and other uniforms identification, accuracy>93%',
    moduletableTd91: 'Car Capture',
    moduletableTd92: 'Target Detection',
    moduletableTd93: 'At the same time support motor vehicle, non-motor vehicle, pedestrian three target detection, detection rate> 95%',
    moduletableTd94: 'Unlicensed vehicles',
    moduletableTd95: 'Unlicensed vehicles can be captured',
    moduletableTd96: 'Plate Recognition',
    moduletableTd97: 'The identification accuracy',
    moduletableTd98: 'License plate recognition accuracy> 99.6%',
    moduletableTd99: 'Plate Type',
    moduletableTd100: 'Support the license plates of green, blue, yellow and special vehicles',
    moduletableTd101: 'Motor vehicle attributes',
    moduletableTd102: 'Car Type',
    moduletableTd103: 'Plate recognition accuracy> 99.6%',
    moduletableTd104: 'Car body color',
    moduletableTd105: 'Support the license plates of green, blue, yellow and special vehicles',
    moduletableTd106: 'Car brand',
    moduletableTd107: 'Identification of vehicle brand, accuracy> 91.5%',

    sdktableTd0: 'Human face analysis',
    sdktableTd1: 'Face detection',
    sdktableTd2: 'Multi-face detection and verification of living bodies (monocular, binocular)',
    sdktableTd3: 'Face recognition',
    sdktableTd4: '1:1: N, support mask mode',
    sdktableTd5: 'The face of a property',
    sdktableTd6: 'Age, gender, whether to wear a mask, whether to wear a hat, whether to wear glasses, expression',
    sdktableTd7: 'Face key points',
    sdktableTd8: '106 key points, fatigue, dozing, closed eyes, concentration',
    sdktableTd9: 'Analysis of the human body',
    sdktableTd10: 'human detection',
    sdktableTd11: 'Head and shoulder test, whole body test, head count, Re-ID',
    sdktableTd12: 'Skeletal key point',
    sdktableTd13: 'Body 18 bone key points, lying down, standing',
    sdktableTd14: 'Gesture recognition',
    sdktableTd15: '18 gestures (1-10, Ok, No, Yes, heart, fist, palm)',
    sdktableTd16: 'Traffic analysis',
    sdktableTd17: 'Vehicle detection',
    sdktableTd18: 'Motor vehicles, non-motor vehicles',
    sdktableTd19: 'License plate recognition',
    sdktableTd20: 'License plate identification, ordinary license plate, green license plate',
    sdktableTd21: 'Vehicle properties',
    sdktableTd22: 'Body color, brand, model',
    sdktableTd23: 'Target detection',
    sdktableTd24: 'Object segmentation',
    sdktableTd25: 'Object segmentation',
    sdktableTd26: 'Obstacles, cracks, defect detection',
    sdktableTd27: 'Character recognition',
    sdktableTd28: 'Identification, text recognition',
    sdktableTd29: 'voice',
    sdktableTd30: 'Echo cancellation',
    sdktableTd31: 'Eliminates acoustic echoes from multiple reflections, supporting single and double masts',
    sdktableTd32: 'Noise suppression',
    sdktableTd33: 'Eliminate background noise, such as fan, air conditioning noise, support single mic and double mic',
    sdktableTd34: 'Key word recognition',
    sdktableTd35: 'Wake up local keyword recognition',

    homecontactdesc: "Feel free to contact us for any information in terms of product introduction, business opportunities, and pre/post-sales support.",
    homebtn: "Send Message",
    footerTel: "Tel",
    footerEmail: "Email",
    footerAddr: "Addr",
    footerFax: "Fax",
    footerAddrdesc: "Building E5, No. 2555 Xiupu Rd, Pudong New District, Shanghai, China",
    footerCopy: "Copyright © 2018 - 2020 Neucore. All Rights Reserved.",
    footerba: "沪ICP备18031700号-1",



    "Who is Neucore?": "Who is Neucore?",
    aboutUsP0: "Founded in Shanghai Zhangjiang Tech in May 2018, Shanghai Neucore Intelligent Technology Co., Ltd (Neucore) is an ARTIFICIAL intelligence (AI) company focusing on the r&d of end side smart operating systems, smart algorithms, and smart devices. It's deeply focused on embedded vision and voice research and development, enabling smart terminal products with AI chips.",
    aboutUsP1: "Based on the unique HCS framework, Neucore can realize the rapid transplantation of algorithms in CPU, NPU, GPU, DSP and other architectures, and realize the intelligent localization of high-precision face capture, face recognition, human body capture, attribute analysis, behavior recognition and other functions.",
    aboutUsP2: "Neucore enables partners to quickly build flexible AI scene applications through intelligent software and hardware products, and provides a complete set of smart business, smart security, smart car and other industry solutions.",
    "Neucore Intelligence is a very creative, dynamic and young Artificial Intelligence company focused on computer vision and deep learning. We were founded in May, 2018 and located in Shanghai city, China. With the mission of making the AI on device for everyone and in everywhere, we are committed to developing innovative Artificial Intelligent solution to meet the requirements of every customer. Our solutions can be used in smart security, smart retail, smart home, automobile, smart factory, and so forth.": "Neucore Intelligence is a very creative, dynamic and young Artificial Intelligence company focused on computer vision and deep learning. We were founded in May, 2018 and located in Shanghai city, China. With the mission of making the AI on device for everyone and in everywhere, we are committed to developing innovative Artificial Intelligent solution to meet the requirements of every customer. Our solutions can be used in smart security, smart retail, smart home, automobile, smart factory, and so forth.",
    "Company Overview": "Company Overview",
    "chinesextra": "",
    "The entrepreneurial team is a master of a famous university or a core of a well-known foreign company. The management team members have 12 years + industry experience.": "The entrepreneurial team is a master of a famous university or a core of a well-known foreign company. The management team members have 12 years + industry experience.",
    "Start-up Team": "Start-up Team",
    "Number Of Workers": "Number Of Workers",
    "Our current team has 33 core employees and plans to grow to more than 50 people this year": "Our current team has 33 core employees and plans to grow to more than 50 people this year",
    "We have full stack technology capabilities from chip design, device drivers, operating systems to application software.": "We have full stack technology capabilities from chip design, device drivers, operating systems to application software.",
    "Technical Strength": "Technical Strength",
    "Registration Time": "Registration Time",
    "Our company started planning in October 2017, and the business registration time is May 2018.": "Our company started planning in October 2017, and the business registration time is May 2018.",
    "The current registered capital of the company is RMB 2.5 million, and the angel round financing has been completed.": "The current registered capital of the company is RMB 2.5 million, and the angel round financing has been completed.",
    "Registered Capital": "Registered Capital",
    "Company Type": "Company Type",
    "We are an artificial intelligence solution provider focused on fast landing.": "We are an artificial intelligence solution provider focused on fast landing.",
    "Meet Our Team": "Meet Our Team",
    "CEO, Cooper is responsible for Neucore’s vision and overall market strategy and execution.": "Founder & CEO, Cooper is responsible for Neucore’s vision and overall market strategy and execution. As director in ARM, Cooper was developing imaging & vision business opportunities in China. In 2005, graduated from Xi'an Jiaotong university with master degree.",
    "VP, Robot is leading artificial intelligence research, collaboration and implementation.": " Co-Founder & VP, Robot is leading Neucore’s algorithm team, focusing on computer vision and voice algorithm research and implementation. Robot was working in Huawei AI lab as principle researcher. In 2005, graduated from XiNan Jiaotong university with master degree.",
    "VP, Wayne is in charge of the NeuOS system architecture and embedded software development.": "Co-Founder & VP, Wayne is leading system team to deliver neuxos and NeuSDK for edge computing devices and platforms, Wayne was working in ARM and Intel Graphics team as principle architect. In 2006, graduated from Shanghai Jiaotong university with master degree.",

    "Product": "Product",
    "AI on device for you all": "AI on device for you all",
    "ProductTitle": "Product Info",
    "Product0": "Smart Camera",
    "Product1": "Smart Box",
    "Product0Int": "Introduction",
    "Product0secH0": "Built-in algorithms",
    "Product0secP0": "Face detection, face recognition, face-id and face deduplication License plate recognition, automotive structured analysis",
    "Product0secH1": "Powerful NeuOS",
    "Product0secP1": "Support private algorithms integration, and algorithms customization Metadata save to local storage or upload to remote server Device function configuration UI",
    "Product0secH2": "NVR-friendly",
    "Product0secP2": "Support mainstream NVRs Protocol world-wide ONVIF, and China GB28281",
    "Product0secH3": "Cloud service",
    "Product0secP3": "AI services and APIs Device management Public and private deployment",
    "Product0secTdesc": "Specification",
    "Product0secT0": "Category",
    "Product0secT1": "Item",
    "Product0secT2": "Description",
    "Product0secB0": "Main Chipset",
    "Product0secB1": "SoC",
    "Product0secB2": "Amlogic Soc, 2 Cores CPU，4TOPS NPU",
    "Product0secB3": "RAM",
    "Product0secB4": "1GB DDR4",
    "Product0secB5": "ROM Storage",
    "Product0secB6": "4GB EMMC",
    "Product0secB7": "Codec",
    "Product0secB8": "Coding standard",
    "Product0secB9": "H.265 / H.264 / MJPEG",
    "Product0secB10": "Coding rate",
    "Product0secB11": "4K@30fps + 1080p@30fps",
    "Product0secB12": "VBR and CBR",
    "Product0secB13": "Support",
    "Product0secB14": "Multi-channel",
    "Product0secB15": "Support",
    "Product0secB16": "Camera",
    "Product0secB17": "Sensor",
    "Product0secB18": "Sony IMX307 / IMX326 / IMX415 , OminiVision OS08A10",
    "Product0secB19": "Day and night mode",
    "Product0secB20": "IR-Cut filter",
    "Product0secB21": "WDR",
    "Product0secB22": "Yes",
    "Product0secB23": "Denoise",
    "Product0secB24": "2D/3D/Color noise reduction",
    "Product0secB25": "ROI",
    "Product0secB26": "Yes",
    "Product0secB27": "Image",
    "Product0secB28": "Image setting",
    "Product0secB29": "Adjustable saturation, brightness, contrast, sharpness, rollover, time of exposure, etc",
    "Product0secB30": "Interface",
    "Product0secB31": "Protocol",
    "Product0secB32": "Onvif / GB28281",
    "Product0secB33": "Networking",
    "Product0secB34": "TCP/IP, HTTP,FTP,DHCP,DNS,DDNS,RTP,RTSP, NTP,UPnP,SMTP",
    "Product0secB35": "Network Interface",
    "Product0secB36": "RJ45 / WIFI",
    "Product0secB37": "Audio Output",
    "Product0secB38": "Support",
    "Product0secB39": "Audio input",
    "Product0secB40": "Support",
    "Product0secB41": "USB",
    "Product0secB42": "USB 2.0",
    "Product0secB43": "Storage",
    "Product0secB44": "TF Card",
    "Product0secB45": "GPIOAO(4x2.54mm fool proof connector/card)",
    "Product0secB46": "Reset",
    "Product0secB47": "1 key reset button",
    "Product0secB48": "System light (LED)",
    "Product0secB49": "1 GPIO(Green)",
    "Product0secB50": "Power light (LED)",
    "Product0secB51": "1 LED power light (Red)",
    "Product0secB52": "Dimension",
    "Product0secB53": "Size",
    "Product0secB54": "150mm(L)*70mm(W)*60mm (H)",

    "ProductHLT": "Product Highlights",
    "ProductHLH0": "Video Input",
    "ProductHLP0": "Supports 1M, 2M, 5M and 8M SDR and WDR sensors Dual MIPI cameras 2D/3D/Color noise reduction",
    "ProductHLH1": "System Configuration",
    "ProductHLP1": "Configurable upload channels – FTP/OSS/MQTT/Redis Manual time set or NTP Original image and structured data upload Whitelist and blacklist on devices",
    "ProductHLH2": "Smart Functions",
    "ProductHLP2": "License plate recognition, automotive structured analysis Face detection, face recognition, face-id and face deduplication Upload the face eigenvalues Support the access control Support the maximum of 50K face database Face database can be batch registered remotely",


    "Product1secH2": "Multi-channel video",
    "Product1secP2": "4-channel1080P/8-channel 720P Support RTSP, MJPEG, UVC protocols Every single channel runs independently",
    "Product1secB0": "Main Chipset",
    "Product1secB1": "SoC",
    "Product1secB2": "Amlogic Soc, 6 Cores CPU，5TOPS NPU",
    "Product1secB3": "RAM",
    "Product1secB4": "2GB DDR4",
    "Product1secB5": "ROM Storage",
    "Product1secB6": "8GB EMMC",
    "Product1secB7": "Codec",
    "Product1secB8": "Coding standard",
    "Product1secB9": "H.265 / H.264 / MJPEG",
    "Product1secB10": "Coding rate",
    "Product1secB11": "1080p@60FPS",
    "Product1secB12": "Decoding standard",
    "Product1secB13": "H.265 / H.264 / VP9",
    "Product1secB14": "Decoding rate",
    "Product1secB15": "4Kx2K@60fps+1x1080P@60FPS",
    "Product1secB16": "Camera",
    "Product1secB17": "Sensor",
    "Product1secB18": "Sony IMX307 / IMX326 / IMX415 , OminiVision OS08A10",
    "Product1secB19": "Day and night mode",
    "Product1secB20": "IR-Cut filter",
    "Product1secB21": "WDR",
    "Product1secB22": "Yes",
    "Product1secB23": "Denoise",
    "Product1secB24": "2D/3D/Color noise reduction",
    "Product1secB25": "ROI",
    "Product1secB26": "Yes",
    "Product1secB27": "Image",
    "Product1secB28": "Image setting",
    "Product1secB29": "Adjustable saturation, brightness, contrast, sharpness, rollover, time of exposure, etc",
    "Product1secB30": "Interface",
    "Product1secB31": "Protocol",
    "Product1secB32": "Onvif / GB28281",
    "Product1secB33": "Networking",
    "Product1secB34": "TCP/IP, HTTP,FTP,DHCP,DNS,DDNS,RTP,RTSP, NTP,UPnP,SMTP",
    "Product1secB35": "Network Interface",
    "Product1secB36": "RJ45 / WIFI / 4G",
    "Product1secB37": "Audio Output",
    "Product1secB38": "Support",
    "Product1secB39": "Audio input",
    "Product1secB40": "Support",
    "Product1secB41": "USB",
    "Product1secB42": "USB 3.0 type-A & Micro USB 2.0",
    "Product1secB43": "Storage",
    "Product1secB44": "TF Card",
    "Product1secB45": "GPIOAO(4x2.54mm fool proof connector/card)",
    "Product1secB46": "Reset",
    "Product1secB47": "1 key reset button",
    "Product1secB48": "System light (LED)",
    "Product1secB49": "1 GPIO(Green)",
    "Product1secB50": "Power light (LED)",
    "Product1secB51": "1 LED power light (Red)",
    "Product1secB52": "Dimension",
    "Product1secB53": "Size",
    "Product1secB54": "150mm(L)*70mm(W)*60mm (H)",
    "Product1secB55": "Resolution and frame rate",
    "Product1secB56": "50Hz: 25fps 1920×1080,1280×720",
    "Product1secB57": "60Hz: 30fps 1920×1080,1280×720",
    "Product1secB58": "UART",
    "Product1secB59": "Display",
    "Product1secB60": "HDMI",

    OpenPlatT0: "Hardware Reference Design",
    OpenPlatD0: "The reference design from silicon vendor includes schematic and PCB layout",
    OpenPlatT1: "neuxos Operating System",
    OpenPlatD1: "neuxos is designed for edge computing platform, built-in AI frameworks and protocols",
    OpenPlatT2: "NeuSDK Android SDK",
    OpenPlatD2: "Android SDK includes face detection, attribute, face recognition with anti-spoofing, temperature recognition",
    OpenPlatT3: "Cloud Docker",
    OpenPlatD3: "Cloud docker is for deployment on private cloud or server, includes device management, AI function and MQTT services",
    OpenPlatT4: "Application Platform",
    OpenPlatD4: "iOS/Android mobile, HTML 5 and embedded applications",
    OpenPlatT5: "AI Model Import",
    OpenPlatD5: "Import a trained model, quantize and export for hardware deployment",


    "ProductAS": "Application Scenario",
    "ProductAS0": "New retail",
    "ProductAS1": "Office analysis",
    "ProductAS2": "Building access",
    "ProductASP2": "Today's common biometric access control systems mainly include fingerprint access control systems, iris access control systems, facial recognition access control systems, and vein recognition access control. It has been further improved in terms of safety, convenience, comfort and management control. Due to the uniqueness of the human body, the biometric key cannot be copied, stolen or forgotten, so it is more sought after by the public.",
    "ProductAS3": "Smart home",
    "ProductASP3": "After monitoring the owner to fall asleep, the TV is automatically turned off, the lighting is adjusted to the sleep mode, and the air conditioner enters an intelligent running state.",

    "Solution": "Solution",
    "AI Turnkey Solution of Device-to-Cloud": "AI Turnkey Solution of Device-to-Cloud",
    "SolutionTip": "Features and advantages of our Solution",
    "SolutionTH0": "AI SoC",
    "SolutionTP0": "Amlogic’s AI SoCs have full functions in terms of ISP, Codec, NN up to 5TOPS.",
    "SolutionTH1": "NeuOS platform",
    "SolutionTP1": "The NeuOS is designed for computer vision and voice applications.",
    "SolutionTH2": "Cloud Service",
    "SolutionTP2": "The cloud service is available through REST APIs, supports public and private deployment.",
    "SolutionTH3": "AI Algorithms",
    "SolutionTP3": "AI modules have been fine-tuned on fully verified, the third-party algorithms could be integrated as well.",
    "SolutionTH4": "Reference Code",
    "SolutionTP4": "Reference code including applications and plugins are open source under GPL copyright",
    "SolutionTH5": "Ecosystem",
    "SolutionTP5": "The ecosystem includes application developers, algorithm developers, forums, middleware partners, and professional ODMs",
    "SolutionTH6": "Low System Cost",
    "SolutionTP6": "Edge computing,GPU-based local or cloud server is optional.AI algorithm on smart camera or smart box is built-in.",
    "SolutionTH7": "Rapid Deployment",
    "SolutionTP7": "Both wireless and ethernet networking are supported.Power-On-Ethernet reduces the power cable.",
    "SolutionCS": "Cloud Server",
    "SolutionCS0": "Device Management",
    "SolutionCP0": "Device status online monitoring",
    "SolutionCP1": "OTA upgrade",
    "SolutionCP2": "Log analysis",
    "SolutionCP3": "Remote control command",
    "SolutionCS1": "AI",
    "SolutionCP10": "Algorithms cross devices",
    "SolutionCP11": "1:1 Billion face recognition",
    "SolutionCP12": "Voice recognition and OCR",
    "SolutionCP13": "NN networking fine-tuning",
    "SolutionCS2": "P2P Video",
    "SolutionCP20": "Signaling service",
    "SolutionCP21": "P2P connection service",
    "SolutionCP22": "Remote camera access",
    "SolutionCP23": "Real-time P2P video streaming",
    "SolutionCS3": "Business",
    "SolutionCP30": "Big data service",
    "SolutionCP31": "Various report",
    "SolutionCP32": "Control and dashboard",
    "SolutionCP33": "H5, and mobile APPs",

    solution0_H0: "New Retail",
    solution0_P0: "Customer portrait,Long-range cruise shop,Traffic statistics",
    solution0_Label0: "Customer portrait",
    solution0_Descript0: "Necuore's new data-driven retail and consumer industry technology solutions help you reinvent the way you do business and the customer experience to mine the value of your own data for consumer-centric smart retailing.",
    solution0_DescriptH0: "Realize the agile operation of retail stores",
    solution0_DescriptP0: "Leveraging advanced technology to facilitate the development of new retail and consumer goods stores to meet the digital expectations of today's rising consumer.",
    solution0_DescriptH1: 'Transform retail customer experience with AI',
    solution0_DescriptP1: 'Artificial intelligence is applied to provide customized marketing information and commodity services for consumers and create intelligent retail customer experience. Wisdom retail customer experience.',
    solution0_DescriptH2: 'Reshaping retail and consumer supply chains',
    solution0_DescriptP2: 'Minimize the impact of global and local events on the supply chain through dynamic retail supply chains.',
    solution0_advantage: "Plan advantage",
    solution0_advantage0: "Hierarchical management",
    solution0_advantage1: "24 hours safe storage",
    solution0_advantage2: "Support docking with the public security platform",
    solution0_advantage3: "Real-time alert push",
    solution0_function: "Function of case",
    solution0_function0: "Heat distribution",
    solution0_function1: "Facial features",
    solution0_function2: "Occupational characteristics",
    solution0_function3: "Hot spot analysis",
    solution0_function4: "On-the-job employees",
    solution0_function5: "Long-range cruise shop",
    solution0_Label1: "Long-range cruise shop",
    solution0_Descript1: "Necuore's new data-driven retail and consumer industry technology solutions help you reinvent the way you do business and the customer experience to mine the value of your own data for consumer-centric smart retailing.",
    solution0_DescriptH00: "Realize the agile operation of retail stores",
    solution0_DescriptP01: "Leveraging advanced technology to facilitate the development of new retail and consumer goods stores to meet the digital expectations of today's rising consumer.",
    solution0_DescriptH01: 'Transform retail customer experience with AI',
    solution0_DescriptP01: 'Artificial intelligence is applied to provide customized marketing information and commodity services for consumers and create intelligent retail customer experience. Wisdom retail customer experience.',
    solution0_DescriptH02: 'Reshaping retail and consumer supply chains',
    solution0_DescriptP02: 'Minimize the impact of global and local events on the supply chain through dynamic retail supply chains.',
    solution0_advantage00: "Plan advantage",
    solution0_advantage01: "Hierarchical management",
    solution0_advantage02: "24 hours safe storage",
    solution0_advantage03: "Support docking with the public security platform",
    solution0_advantage04: "Real-time alert push",
    solution0_function00: "Function of case",
    solution0_function01: "Remote watch shop",
    solution0_function02: "Real-time on inspection",
    solution0_function03: "Shop dynamic",
    solution0_function04: "Hot spot analysis",
    solution0_function05: "On-the-job employees",
    solution0_function06: "Long-range cruise shop",
    solution0_Label2: "Traffic statistics",
    solution0_Descript2: "Necuore's new data-driven retail and consumer industry technology solutions help you reinvent the way you do business and the customer experience to mine the value of your own data for consumer-centric smart retailing.",
    solution0_DescriptH000: "Realize the agile operation of retail stores",
    solution0_DescriptP001: "Leveraging advanced technology to facilitate the development of new retail and consumer goods stores to meet the digital expectations of today's rising consumer.",
    solution0_DescriptH001: 'Transform retail customer experience with AI',
    solution0_DescriptP001: 'Artificial intelligence is applied to provide customized marketing information and commodity services for consumers and create intelligent retail customer experience. Wisdom retail customer experience.',
    solution0_DescriptH002: 'Reshaping retail and consumer supply chains',
    solution0_DescriptP002: 'Minimize the impact of global and local events on the supply chain through dynamic retail supply chains.',
    solution0_advantage000: "Plan advantage",
    solution0_advantage001: "Hierarchical management",
    solution0_advantage002: "24 hours safe storage",
    solution0_advantage003: "Support docking with the public security platform",
    solution0_advantage004: "Real-time alert push",
    solution0_function000: "Function of case",
    solution0_function001: "VIP Customer identification",
    solution0_function002: "The resident time",
    solution0_function003: "Traffic statistics",
    solution0_function004: "Hot spot analysis",
    solution0_function005: "On-the-job employees",
    solution0_function006: "Long-range cruise shop",

    solution1_H0: "Smart Security",
    solution1_P0: "Human body analysis, vehicle analysis, object analysis",
    solution1_Label0: "Human body analysis",
    solution1_Descript0: "Necuore's new data-driven retail and consumer industry technology solutions help you reinvent the way you do business and the customer experience to mine the value of your own data for consumer-centric smart retailing.",
    solution1_DescriptH0: "Realize the agile operation of retail stores",
    solution1_DescriptP0: "Leveraging advanced technology to facilitate the development of new retail and consumer goods stores to meet the digital expectations of today's rising consumer.",
    solution1_DescriptH1: 'Transform retail customer experience with AI',
    solution1_DescriptP1: 'Artificial intelligence is applied to provide customized marketing information and commodity services for consumers and create intelligent retail customer experience. Wisdom retail customer experience.',
    solution1_DescriptH2: 'Reshaping retail and consumer supply chains',
    solution1_DescriptP2: 'Minimize the impact of global and local events on the supply chain through dynamic retail supply chains.',
    solution1_advantage: "Plan advantage",
    solution1_advantage0: "Hierarchical management",
    solution1_advantage1: "24 hours safe storage",
    solution1_advantage2: "Support docking with the public security platform",
    solution1_advantage3: "Real-time alert push",
    solution1_function: "Function of case",
    solution1_function0: "VIP Customer identification",
    solution1_function1: "The resident time",
    solution1_function2: "Traffic statistics",
    solution1_function3: "Hot spot analysis",
    solution1_function4: "On-the-job employees",
    solution1_function5: "Long-range cruise shop",
    solution1_Label1: "vehicle analysis",
    solution1_Descript1: "Necuore's new data-driven retail and consumer industry technology solutions help you reinvent the way you do business and the customer experience to mine the value of your own data for consumer-centric smart retailing.",
    solution1_DescriptH00: "Realize the agile operation of retail stores",
    solution1_DescriptP01: "Leveraging advanced technology to facilitate the development of new retail and consumer goods stores to meet the digital expectations of today's rising consumer.",
    solution1_DescriptH01: 'Transform retail customer experience with AI',
    solution1_DescriptP01: 'Artificial intelligence is applied to provide customized marketing information and commodity services for consumers and create intelligent retail customer experience. Wisdom retail customer experience.',
    solution1_DescriptH02: 'Reshaping retail and consumer supply chains',
    solution1_DescriptP02: 'Minimize the impact of global and local events on the supply chain through dynamic retail supply chains.',
    solution1_advantage00: "Plan advantage",
    solution1_advantage01: "Hierarchical management",
    solution1_advantage02: "24 hours safe storage",
    solution1_advantage03: "Support docking with the public security platform",
    solution1_advantage04: "Real-time alert push",
    solution1_function00: "Function of case",
    solution1_function01: "Vehicle detection",
    solution1_function02: "Traffic statistics",
    solution1_function03: "Vehicle recognition",
    solution1_function04: "Hot spot analysis",
    solution1_function05: "On-the-job employees",
    solution1_function06: "Long-range cruise shop",
    solution1_Label2: "object analysis",
    solution1_Descript2: "Necuore's new data-driven retail and consumer industry technology solutions help you reinvent the way you do business and the customer experience to mine the value of your own data for consumer-centric smart retailing.",
    solution1_DescriptH000: "Realize the agile operation of retail stores",
    solution1_DescriptP001: "Leveraging advanced technology to facilitate the development of new retail and consumer goods stores to meet the digital expectations of today's rising consumer.",
    solution1_DescriptH001: 'Transform retail customer experience with AI',
    solution1_DescriptP001: 'Artificial intelligence is applied to provide customized marketing information and commodity services for consumers and create intelligent retail customer experience. Wisdom retail customer experience.',
    solution1_DescriptH002: 'Reshaping retail and consumer supply chains',
    solution1_DescriptP002: 'Minimize the impact of global and local events on the supply chain through dynamic retail supply chains.',
    solution1_advantage000: "Plan advantage",
    solution1_advantage001: "Hierarchical management",
    solution1_advantage002: "24 hours safe storage",
    solution1_advantage003: "Support docking with the public security platform",
    solution1_advantage004: "Real-time alert push",
    solution1_function000: "Function of case",
    solution1_function001: "Bag check",
    solution1_function002: "Quality control",
    solution1_function003: "Self-checkout",
    solution1_function004: "Hot spot analysis",
    solution1_function005: "On-the-job employees",
    solution1_function006: "Long-range cruise shop",

    solution2_H0: "Smart Vehicle",
    solution2_P0: "Driver behavior analysis, advanced assisted driving",
    solution2_Label0: "Driver behavior analysis",
    solution2_Descript0: "Necuore's new data-driven retail and consumer industry technology solutions help you reinvent the way you do business and the customer experience to mine the value of your own data for consumer-centric smart retailing.",
    solution2_DescriptH0: "Realize the agile operation of retail stores",
    solution2_DescriptP0: "Leveraging advanced technology to facilitate the development of new retail and consumer goods stores to meet the digital expectations of today's rising consumer.",
    solution2_DescriptH1: 'Transform retail customer experience with AI',
    solution2_DescriptP1: 'Artificial intelligence is applied to provide customized marketing information and commodity services for consumers and create intelligent retail customer experience. Wisdom retail customer experience.',
    solution2_DescriptH2: 'Reshaping retail and consumer supply chains',
    solution2_DescriptP2: 'Minimize the impact of global and local events on the supply chain through dynamic retail supply chains.',
    solution2_advantage: "Plan advantage",
    solution2_advantage0: "Hierarchical management",
    solution2_advantage1: "24 hours safe storage",
    solution2_advantage2: "Support docking with the public security platform",
    solution2_advantage3: "Real-time alert push",
    solution2_function: "Function of case",
    solution2_function0: "Fatigue driving",
    solution2_function1: "Travel safety",
    solution2_function2: "Traffic statistics",
    solution2_function3: "Disputes forensics",
    solution2_function4: "On-the-job employees",
    solution2_function5: "Long-range cruise shop",
    solution2_Label1: "Long-range cruise shop",
    solution2_Descript1: "Necuore's new data-driven retail and consumer industry technology solutions help you reinvent the way you do business and the customer experience to mine the value of your own data for consumer-centric smart retailing.",
    solution2_DescriptH00: "Realize the agile operation of retail stores",
    solution2_DescriptP01: "Leveraging advanced technology to facilitate the development of new retail and consumer goods stores to meet the digital expectations of today's rising consumer.",
    solution2_DescriptH01: 'Transform retail customer experience with AI',
    solution2_DescriptP01: 'Artificial intelligence is applied to provide customized marketing information and commodity services for consumers and create intelligent retail customer experience. Wisdom retail customer experience.',
    solution2_DescriptH02: 'Reshaping retail and consumer supply chains',
    solution2_DescriptP02: 'Minimize the impact of global and local events on the supply chain through dynamic retail supply chains.',
    solution2_advantage00: "Plan advantage",
    solution2_advantage01: "Hierarchical management",
    solution2_advantage02: "24 hours safe storage",
    solution2_advantage03: "Support docking with the public security platform",
    solution2_advantage04: "Real-time alert push",
    solution2_function00: "Function of case",
    solution2_function01: "Lane departure warning",
    solution2_function02: "Blind spot monitoring",
    solution2_function03: "Adaptive cruise",
    solution2_function04: "Hot spot analysis",
    solution2_function05: "On-the-job employees",
    solution2_function06: "Long-range cruise shop",
    solution2_Label2: "advanced assisted driving",
    solution2_Descript2: "Necuore's new data-driven retail and consumer industry technology solutions help you reinvent the way you do business and the customer experience to mine the value of your own data for consumer-centric smart retailing.",
    solution2_DescriptH000: "Realize the agile operation of retail stores",
    solution2_DescriptP001: "Leveraging advanced technology to facilitate the development of new retail and consumer goods stores to meet the digital expectations of today's rising consumer.",
    solution2_DescriptH001: 'Transform retail customer experience with AI',
    solution2_DescriptP001: 'Artificial intelligence is applied to provide customized marketing information and commodity services for consumers and create intelligent retail customer experience. Wisdom retail customer experience.',
    solution2_DescriptH002: 'Reshaping retail and consumer supply chains',
    solution2_DescriptP002: 'Minimize the impact of global and local events on the supply chain through dynamic retail supply chains.',
    solution2_advantage000: "Plan advantage",
    solution2_advantage001: "Hierarchical management",
    solution2_advantage002: "24 hours safe storage",
    solution2_advantage003: "Support docking with the public security platform",
    solution2_advantage004: "Real-time alert push",
    solution2_function000: "Function of case",
    solution2_function001: "VIP Customer identification",
    solution2_function002: "The resident time",
    solution2_function003: "Traffic statistics",
    solution2_function004: "Hot spot analysis",
    solution2_function005: "On-the-job employees",
    solution2_function006: "Long-range cruise shop",

    "Join Us": "Join Us",
    "Do something that is changing humanity": "Do something that is changing humanity",
    "JoinSecH0": "Campus Recruiting",
    "JoinSecH1": "Social recruitment",
    "JoinSecBtn": "View job",
    "JoinTitle": "Neucore",
    "JoinP": "The brave Neucore people, with a firm belief, are on the road to expanding the new frontiers of artificial intelligence. This road is both dangerous and interesting, and has produced countless wise speeches.",

    "Social recruitment": "Social recruitment",
    "We hope to enhance the relationship between people and smart devices through our own products.": "We hope to enhance the relationship between people and smart devices through our own products.",
    "SocialH0": "Computer vision algorithm engineer",
    "SocialP0": "Work location: Shanghai",
    "SocialSecH0": "Responsibilities",
    "SocialSecP0": "1. Responsible for algorithms and their integration (target detection and recognition, face recognition, behavior recognition, etc.)",
    "SocialSecP01": "2. Responsible for the landing of the algorithm in specific application scenarios",
    "SocialSecP02": "3. Collaborate with the team to optimize the algorithm and deliver quality delivery",
    "SocialSecH01": "Job Requirements",
    "SocialSecP010": "1. 3 years of work experience, solid Linux embedded development experience",
    "SocialSecP011": "2. Have image processing foundation, understand opencv, openvx, etc.",
    "SocialSecP012": "3. Interested in learning the AI algorithm training framework, including but not limited to TensorFlow and caffe",

    "SocialH1": "Computer Vision Algorithm Engineer (Algorithm Application and Integration)",
    "SocialP1": "Work location: Shanghai",
    "SocialSecH10": "Responsibilities",
    "SocialSecP10": "1. Responsible for the transplantation, debugging, optimization and problem solving of computer vision algorithms on the chip platform",
    "SocialSecP11": "2. Responsible for the research and development of common algorithms for image processing and computer vision",
    "SocialSecP12": "3. Responsible for algorithm packaging and publishing work and system joint debugging",
    "SocialSecH11": "Job Requirements",
    "SocialSecP110": "1. Artificial intelligence or signal processing (image orientation) or pattern recognition or computer technology related majors",
    "SocialSecP111": "2. Skilled in C/C++/Python programming",
    "SocialSecP112": "3. Experience in embedded programming and debugging is preferred",
    "SocialSecP113": "4. Familiar with openCV programming first",
    "SocialSecP114": "5. Familiar with openVX programming first",
    "SocialSecP115": "6. Familiar with caffe/tensorflow/keras framework for CNN image algorithm (recognition, detection, segmentation, tracking)",

    "SocialH2": "Embedded Linux platform project development",
    "SocialP2": "Work location: Shanghai",
    "SocialSecH20": "Responsibilities",
    "SocialSecP20": "1. Responsible for embedded Linux platform project development work",
    "SocialSecP21": "2. Participation and service platform interface docking and debugging",
    "SocialSecP22": "3. Participate in technical implementation discussions of client products, framework design",
    "SocialSecH21": "Job Requirements",
    "SocialSecP210": "1. 3+ years of C/C++ development experience",
    "SocialSecP211": "2. Familiar with Linux C/C++ programming, skilled in using STL template library",
    "SocialSecP212": "3. Familiar with multi-threaded development",
    "SocialSecP213": "4. Familiar with http, socket network program development",
    "SocialSecP214": "5. Familiar with common data structures and algorithms",
    "SocialSecP215": "6. Familiar with sqlite database programming",
    "SocialSecP216": "7. Have experience in embedded Linux project development",
    "SocialSecP217": "8. Familiar with common design patterns",
    "SocialSecP218": "9. Familiar with common exception handling and troubleshooting methods",

    "SocialSecEmail": "send your resume to : hr@neucore.com",

    "TopContact": "Contact us",
    "Send Message": "sendMessage",

    AboutMission: "Mission, Vision & Values",
    AboutMissT: "AI on device for you all",
    AboutMiss1T: "To be the leading vender of edge AI in china",
    AboutMiss2T: "Customer Collaboration Innovation Commitment",

}
export default en;